export const formatCandidateLocation = (item: {
  location?: string | null;
  location_city?: string | null;
  location_country?: string | null;
}): string => {
  const country = item.location_country?.trim();
  const city = item.location_city?.trim();
  if (country && city) return `${country}, ${city}`;
  if (country || city) return country || city || '';
  return (item.location || '').trim();
};
